module.exports = __webpack_public_path__ + "img/adora_cointreasure.2a3f367.png";